/**
 * ADS-B Traffic Types
 * Types for aircraft alerts received from the tactical warning system SSE endpoint
 */

export interface TrailPoint {
  lat: number;
  lon: number;
  timestamp: number; // ms since epoch, client-received time
}

export interface AircraftAlert {
  hex: string;
  flight: string;
  registration: string;
  type: string;
  altitude: number; // Geometric altitude, metres
  groundSpeed: number;
  track: number;
  lat: number;
  lon: number;
  timestamp: string;
  alertLevel: string;
  alertMessage: string;
  distance?: number; // Distance from query point in km
  baroRate?: number; // Vertical rate from barometric altitude, ft/min
  geomRate?: number; // Vertical rate from geometric altitude, ft/min
}

export type SseConnectionStatus = 'disconnected' | 'connecting' | 'connected' | 'error';

/**
 * Single source of truth for alert-level colors, shared between the deck.gl
 * traffic layers (dot, track line) and the DOM-based off-screen indicators,
 * so they stay visually consistent.
 */
export const ALERT_LEVEL_COLORS: Record<string, string> = {
  CRITICAL: '#ff0000', // Red
  WARNING: '#ffc800', // Yellow
  INFO: '#ffffff', // White
};
export const DEFAULT_ALERT_LEVEL_COLOR = '#969696'; // Grey

export const getAlertLevelColor = (alertLevel: string): string =>
  ALERT_LEVEL_COLORS[alertLevel] ?? DEFAULT_ALERT_LEVEL_COLOR;

/**
 * Screen-space indicator for CRITICAL/WARNING traffic that has moved outside
 * the current map viewport: an arrow clamped to the viewport edge, pointing
 * toward the aircraft, plus the real-world distance from that edge point to
 * the aircraft's actual position.
 */
export interface OffScreenTrafficIndicator {
  hex: string;
  alertLevel: string;
  x: number;
  y: number;
  angleDeg: number;
  distanceKm: number;
}
